import React from "react";
import {Button, Card, Col, DatePicker, Form, Input, message, Row, Skeleton} from "antd";
import {useFormik} from "formik";
import {useTranslation} from "react-i18next";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../hooks/useStore";
import moment from "moment";
import * as yup from "yup";

export const AuthorizedIDForm = ({subCompany, loading, refetch, okButtonText, isCustomer}) => {
    const stores = useStore();

    const {t} = useTranslation();

    const formik = useFormik({
        initialValues: {
            subCompanyId: subCompany?._id,
            authorizedID: subCompany?.authorizedID,
            authorizedBirthYear: undefined
        },
        validationSchema: yup.object().shape({
            authorizedID: yup.string().required("TCKN zorunlu alan"),
            authorizedBirthYear: yup.string().required("Doğum Yılı zorunlu alan")
        }),
        enableReinitialize: true,
        onSubmit: async vals => {
            const {subCompanyId, authorizedID, authorizedBirthYear} = vals;

            try {
                const resultUpdateSubCompanyAuthorizedID = await stores.companyStore.updateSubCompanyAuthorizedID(
                    {
                        subCompanyId,
                        authorizedID,
                        authorizedBirthYear: moment(authorizedBirthYear).format("YYYY")
                    }
                );
                if (resultUpdateSubCompanyAuthorizedID?.success !== true) {
                    message.error(resultUpdateSubCompanyAuthorizedID?.message);
                    return false;
                }
                refetch();
            } catch (error) {
                console.log(error);
                Sentry.captureException(error);
            }
        }
    });

    const {
        values,
        handleSubmit,
        handleChange,
        setFieldValue,
        isSubmitting,
        errors,
        touched
    } = formik;

    return (
        <Card title="Yetkili Kişi Kimlik Bilgileri" style={{marginTop: "20px"}}>
            {loading ? (
                <Skeleton active />
            ) : (
                <Form
                    labelCol={{span: 24}}
                    wrapperCol={{span: 24}}
                    onFinish={data => {
                        handleSubmit(data);
                    }}
                    autoComplete="off"
                    data-testid="billingInformationForm"
                >
                    <Row>
                        <Col span={24}>
                            <Row gutter={[16, 16]}>
                                <Col span={24}>
                                    <Form.Item>
                                        <h4>Yetkili Kişi Adı</h4>
                                        <Input
                                            name="authorizedPerson"
                                            value={subCompany?.authorizedPerson}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={subCompany?.authorizedID || isCustomer ? 24 : 12}>
                                    <Form.Item
                                        validateStatus={
                                            errors.authorizedID && touched.authorizedID
                                                ? "error"
                                                : "success"
                                        }
                                        help={
                                            errors.authorizedID && touched.authorizedID
                                                ? errors.authorizedID
                                                : null
                                        }
                                    >
                                        <h4>Yetkili Kişi TCKN</h4>
                                        <Input
                                            name="authorizedID"
                                            value={values?.authorizedID}
                                            maxLength={11}
                                            disabled={subCompany?.authorizedID}
                                            onChange={e => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                e.target.value = value;
                                                handleChange(e);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                                {!subCompany?.authorizedID && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%"
                                        }}
                                    >
                                        <Col span={12}>
                                            <Form.Item
                                                validateStatus={
                                                    errors.authorizedBirthYear &&
                                                    touched.authorizedBirthYear
                                                        ? "error"
                                                        : "success"
                                                }
                                                help={
                                                    errors.authorizedBirthYear &&
                                                    touched.authorizedBirthYear
                                                        ? errors.authorizedBirthYear
                                                        : null
                                                }
                                            >
                                                <h4>Doğum Yılı</h4>
                                                <DatePicker.YearPicker
                                                    style={{width: "100%"}}
                                                    name="authorizedBirthYear"
                                                    format="YYYY"
                                                    onSelect={date => {
                                                        setFieldValue("authorizedBirthYear", date);
                                                    }}
                                                    value={values?.authorizedBirthYear}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {isCustomer && (
                                            <Col span={12}>
                                                <Form.Item>
                                                    <h4 style={{visibility: "hidden"}}>Kaydet</h4>
                                                    <Button
                                                        disabled={isSubmitting}
                                                        type="ghost"
                                                        htmlType="submit"
                                                        data-testid="submitButton"
                                                        style={{
                                                            width: "100%",
                                                            backgroundColor: isCustomer
                                                                ? "#AEFF01"
                                                                : "transparent"
                                                        }}
                                                    >
                                                        {okButtonText ||
                                                            t("actions.save", {ns: "common"})}
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </div>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    {!subCompany?.authorizedID ||
                        (!isCustomer && (
                            <Row type="flex" justify="end">
                                <CustomButton
                                    disabled={isSubmitting}
                                    type="ghost"
                                    htmlType="submit"
                                    data-testid="submitButton"
                                    style={{
                                        backgroundColor: isCustomer ? "#AEFF01" : "transparent"
                                    }}
                                >
                                    {okButtonText || t("actions.save", {ns: "common"})}
                                </CustomButton>
                            </Row>
                        ))}
                </Form>
            )}
        </Card>
    );
};
